/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Upload_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to upload recording: {error}" |
*
* @param {Audio_Recorder_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_upload_failed = /** @type {((inputs: Audio_Recorder_Upload_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Upload_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du téléversement de l'enregistrement : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aufzeichnung konnte nicht hochgeladen werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare la registrazione: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить запись: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al cargar la grabación: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`录音上传失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`録画のアップロードに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`रिकॉर्डिंग अपलोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao carregar a gravação: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to upload recording: ${i?.error}`)
});